export class DownloadMobileAppWidgetSettings {
  public androidAppUrl: string;
  public iosAppUrl: string;
  public description: string;
}
